import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { PlanScheduledRepository } from "../../repositories/scheduler.repository";
import { CreateSchedulerInstanceRequest } from "../../domain/requests/Scheduler/create-scheduler-instance";
import { ExceptionDates } from "../../domain/models/scheduler/exception-dates";

@Injectable({ providedIn: 'root' })
export class CreateSchedulerInstanceUseCase implements UseCase<CreateSchedulerInstanceRequest, ExceptionDates> {

  constructor(private readonly planScheduledRepository: PlanScheduledRepository) {
  }

  execute(request:CreateSchedulerInstanceRequest): Observable<ExceptionDates> {
    return this.planScheduledRepository.createSchedulerInstance(request);
  }

}